export enum PerformanceChartData {
  TVL = 'TVL',
  APR = 'APR',
  SHARE_PRICE = 'SHARE_PRICE',
}

export enum PerformanceChartPeriod {
  WEEK = '7',
  MONTH = '30',
  QUARTER = '90',
  ALL_TIME = 'all',
}

export interface ChartDataPoint {
  date: string;
  tooltipLabel: string;
  value: number | null;
  tvl: number| null;
  apr: number | null;
  sharePrice: number | null;
  tvlTooltip: string | null;
  aprTooltip: string | null;
  sharePriceTooltip: string | null;
  rewardsTooltip: string | null;
  timestamp: string;
  currentEpochId: string | null;
  epochStart: string | null;
  epochEnd: string | null;
}

export interface RechartsPayloadItem {
  value: number;
  payload: ChartDataPoint;
}

export type TicksWithDate = {
  date: string;
};